<dx-load-panel
  class="dark-overlay"
  [visible]="loadingService.loading()"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [message]="'Loading...' | translate"
>
</dx-load-panel>
